import React, {Component} from 'react';


class SiteInfoComponent extends Component {
  render() {
    return (
        <div>
          <p>Hardware Type: {this.props.info.hw_type}</p>
          <p>S/N: {this.props.info.modem_sn}</p>
          <p>Network: {this.props.info.network}</p>
          <p>Staellite: {this.props.info.satellite}</p>
          <p>Transponder: {this.props.info.tx_transponder}</p>
          <p>Inroute Group: {this.props.info.inroutegroup}</p>
          <p>Sofware Verison: {this.props.info.sw_version}</p>
          <p>Status: {this.props.info.active_status}</p>
          <p>State: {this.props.info.state} ({this.props.info.state_details})</p>
          <p>FAP: {this.props.info.fap}</p>
          <p>QoS Profile (Upstream): {this.props.info.qosprofile_upstream}</p>
          <p>QoS Upstream: {this.props.info.qos_upstream}</p>
          <p>QoS Downstream: {this.props.info.qos_downstream}</p>
          <p>Upstream RX Polarization: {this.props.info.tx_rxpol}</p>
          <p>Upstream TX Polarization: {this.props.info.tx_txpol}</p>
          <p>Downstream RX Polarization: {this.props.info.rx_rxpol}</p>
          <p>Downstream TX Polarization: {this.props.info.rx_txpol}</p>

          <p>Subnetmask: {this.props.info.subnet}</p>
          <p>Filter: {this.props.info.filter}</p>
          <p>Downlink Center Frequency: {this.props.info.downlinkcenterfreq}</p>
          <p>Uplink Center Frequency: {this.props.info.uplinkcenterfreq}</p>
          <p>Downstream Transponder: {this.props.info.rx_transponder}</p>
        </div>

    );
  }

};

export default SiteInfoComponent;



// WEBPACK FOOTER //
// ./src/components/SiteInfoComponent.js